/* eslint-disable */
// Create CustomEvent for IE 11
(function () {
  if (typeof window.CustomEvent === "function") return false; //If not IE

  function CustomEvent (event, params) {
    params = params || {bubbles: false, cancelable: false, detail: undefined};
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

export default function KRPANO (panoId) {
  const VIEW_PARAMS = {
    fov: 90,
    fovmin: 40,
    fovmax: 90
  }
  const PANO_VIEW_PARAMS = {
    fov: 90,
    fovmin: 60,
    fovmax: 90
  }

  function init(targetElementId, xmlPath, defaultSettings) {
    let settings = {}
    if (defaultSettings) settings = defaultSettings
    settings['image.prealign'] = ''

    try {
      embedpano({
        target: targetElementId,
        html5: 'only+webgl',
        xml: xmlPath,
        id: panoId,
        vars: settings
      })
    } catch (e) {
      console.log(e)
    }

    on('onloadcomplete', () => {
      var myCustomEvent = new CustomEvent('onloadscenecompleted')
      document.dispatchEvent(myCustomEvent)
    })

    on('onviewchange', () => {
      var myCustomEventOnviewchange = new CustomEvent('onviewchange')
      document.dispatchEvent(myCustomEventOnviewchange)
    })
    on('onclick', () => {
      var myCustomEventOnClick = new CustomEvent('onclick')
      document.dispatchEvent(myCustomEventOnClick)
    })
    on('onmousewheel', () => {
      // console.log('onmousewheel')
      // console.log(_krpano().get('view.fov'))
      var myCustomEventOnMouseWheel = new CustomEvent('onmousewheel')
      document.dispatchEvent(myCustomEventOnMouseWheel)
    })
    if (targetElementId === 'pano') {
      window.krpano = _krpano()
    }
  }

  function loadScene(urlImage, vars, xml, blend = 'BLEND(1)', viewSettings = null) {
    var varsString = ''
    if (vars == undefined) {
      vars = null
    } else {
      for (let key in vars) {
        varsString += key + '=' + vars[key] + '&'
      }
    }

    // BUILD VIEW TAGS
    let view = '<view'
    let viewObject = Object.assign({}, VIEW_PARAMS)

    // merge prop view settings
    if (viewSettings instanceof Object) {
      Object.assign(viewObject, viewSettings)
    }
    // convert viewObject to xml tag
    for (const param in viewObject) {
      view += ` ${param}="${viewObject[param]}"`
    }
    view += '/>'

    let krpanoXml = '<krpano logkey="false" version="1.20"><skin_settings maps="false" maps_type="bing" maps_bing_api_key="" maps_zoombuttons="false" gyro="true" title="true" thumbs="true" thumbs_width="120" thumbs_height="80" thumbs_padding="10" thumbs_crop="0|40|240|160" thumbs_opened="false" thumbs_text="false" thumbs_dragging="true" thumbs_onhoverscrolling="false" thumbs_scrollbuttons="false" thumbs_scrollindicator="false" thumbs_loop="false" tooltips_thumbs="false" tooltips_hotspots="false" tooltips_mapspots="false" loadscene_flags="KEEPBASE" loadscene_blend="BLEND(1)" controlbar_offset="20"/> <control mousetype="drag2d" mouseaccelerate="0.2"/>'
    if (xml) {
      krpanoXml = krpanoXml + '<preview url="'+urlImage+'/preview.jpg" />' + xml + view + '</krpano>'
    } else {
      krpanoXml += `<preview url="${urlImage}" /><image><sphere url="${urlImage}" /></image>${view}</krpano>`
    }
    _krpano().call(`loadxml(${krpanoXml}, ${varsString},IGNOREKEEP,${blend});`)
  }

  function loadVideo(videoUrl, videoPoster, vars, blend = 'BLEND(1)', viewSettings = null) {
    var varsString = ''
    if (vars == undefined) {
      vars = null
    } else {
      for (let key in vars) {
        varsString += key + '=' + vars[key] + '&'
      }
    }

    // BUILD VIEW TAGS
    let view = '<view'
    let viewObject = Object.assign({}, PANO_VIEW_PARAMS)

    // merge prop view settings
    if (viewSettings instanceof Object) {
      Object.assign(viewObject, viewSettings)
    }
    // convert viewObject to xml tag
    for (const param in viewObject) {
      view += ` ${param}="${viewObject[param]}"`
    }
    view += '/>'

    if (isSafari) {
      let krpanoXml = '<krpano logkey="false" version="1.20"><skin_settings maps="false" maps_type="bing" maps_bing_api_key="" maps_zoombuttons="false" gyro="true" title="true" thumbs="true" thumbs_width="120" thumbs_height="80" thumbs_padding="10" thumbs_crop="0|40|240|160" thumbs_opened="false" thumbs_text="false" thumbs_dragging="true" thumbs_onhoverscrolling="false" thumbs_scrollbuttons="false" thumbs_scrollindicator="false" thumbs_loop="false" tooltips_thumbs="false" tooltips_hotspots="false" tooltips_mapspots="false" loadscene_flags="KEEPBASE" loadscene_blend="BLEND(1)" controlbar_offset="20"/> <control mousetype="drag2d" mouseaccelerate="0.2"/>'

      krpanoXml += `<scene name="videopano"><include url="/static/libraries/skin/video/videointerface_safari.xml" /><plugin name="video" url.html5="/static/libraries/plugins/video/videoplayer_safari.js" pausedonstart="true" loop="true" volume="1.0" onloaded="add_video_sources();"/><image><sphere url="plugin:video" /></image>${view}<action name="add_video_sources">videointerface_addsource("1920x960", "${videoUrl}", "");videointerface_play("1920x960");</action></scene></krpano>`

      _krpano().call(`loadxml(${krpanoXml}, ${varsString},IGNOREKEEP,${blend});`)
      _krpano().call('loadscene(videopano)');
    } else {
      let krpanoXml = `<krpano logkey="false"><image><sphere url="plugin:video" /></image><plugin name="video" url="/static/libraries/plugins/video/videoplayer.js" videourl="${videoUrl}" videotype="application/x-mpegURL" devices="panovideosupport" onloaded="skin_video_setup();" /> <action name="no_pano_video_error" autorun="onstart" devices="no-panovideosupport">error("Sorry, but your browser doesn't support panoramic videos!");</action><include url="/static/libraries/skin/video/videointerface.xml" />${view}</krpano>`
      _krpano().call(`loadxml(${krpanoXml}, ${varsString},IGNOREKEEP,${blend});`)
    }

  }

  function on(eventName, callback, eventId) {
    if (typeof callback === 'function' && _krpano() != null) {
      if (eventId) {
        try {
          _krpano().set("events['" + eventId + "']." + eventName, callback)
        } catch (e) {
          console.log(e)
        }
      } else {
        // Register to global event
        try {
          _krpano().set("events." + eventName, callback)
        } catch (e) {
          console.log(e)
        }
      }
    }
  }

  function _krpano() {
    return document.getElementById(panoId)
  }

  return {
    init: init,
    krpano: _krpano,
    loadScene: loadScene,
    loadVideo: loadVideo
  }
}



// WEBPACK FOOTER //
// ./src/plugins/krpano.js